export default {"src":"/_next/static/media/what-is-electronic-signature.d2980dc5.gif","height":497,"width":620};